import { Injectable } from '@angular/core';

import { AuthService } from "../../../shared/services/auth.service";
import { editRoute, newRoute } from "../../../shared/services/data.service";
import { abastecimentosRoute } from "../../shared/data.service";
import { combustiveisRoute } from "./data.service";

@Injectable()
export class CombustivelNavigationService {

  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = abastecimentosRoute + '/' + combustiveisRoute;
    this._authService.navigateTo(router);
  }

  goToNew() {
    var router: string = abastecimentosRoute + '/' + combustiveisRoute + '/' + newRoute;
    this._authService.navigateTo(router);
  }

  goToEdit(objectId: number) {
    var router: string = abastecimentosRoute + '/' + combustiveisRoute + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/combustiveis/shared/combustivel-navigation.service.ts
 **/